import Form from '@utils/form'
import options from './config/options'
import search from './config/search'

export default new Form('performance.qualitativeProject')
  .url('/srmQualitativeItem/addSrmQualitativeItem', process.env.VUE_APP_PURCHASE_API)
  .title('formTitle.baseInfo')
  .add('qualitativeItemNo').required()
  .add('qualitativeItemName').required()
  .add('deptId').select(search).required()
  .add('status').op(options).default('0')
  .add('remarks').merge('textarea')
  .end()
